/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconUpdate/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconUpdate({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconUpdate",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconUpdate.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1BOU0k': alignSelf,'--mt-2-1BOU0k': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1BOU0k': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1BOU0k': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1BOU0k': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1BOU0k': opacity,'--w-10-1BOU0k': typeof width === 'number' ? `${width}px` : width,'--h-11-1BOU0k': typeof height === 'number' ? `${height}px` : height,'--a-7-1BOU0k': isAnimated ? animation : "none",'--sd-8-1BOU0k': isAnimated ? strokeDashoffset : 0,'--sd-9-1BOU0k': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconUpdate.SvgPath"
  data-view-path={viewPath}
 d="M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64A8.937 8.937 0 0012 3a9 9 0 109 9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
 style={{'--f-12-1BOU0k': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}